var React = require('react');

function IconDataAnalyticsLanding (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.9795 19.0608C23.7038 24.4425 18.1178 27.6453 12.3237 26.8904C6.52961 26.1356 1.95059 21.6086 1.12966 15.8235C0.308724 10.0384 3.44751 4.41621 8.80285 2.07922","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.0066 14.0027C27.0066 10.5542 25.6367 7.2469 23.1982 4.80841C20.7597 2.36993 17.4524 1 14.0039 1V14.0027H27.0066Z","stroke":"#DDDDDD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconDataAnalyticsLanding.defaultProps = {"width":"29","height":"28","viewBox":"0 0 29 28","fill":"none"};

module.exports = IconDataAnalyticsLanding;

IconDataAnalyticsLanding.default = IconDataAnalyticsLanding;
